import ManualLinkSetup from '@monetr/interface/components/setup/manual/ManualLinkSetup';

export default function SetupManualLinkPage(): JSX.Element {
  return <ManualLinkSetup showLogoutFooter />;
}
